import { render, staticRenderFns } from "./CategoriesComponent.vue?vue&type=template&id=e31d23ee&scoped=true"
import script from "./CategoriesComponent.vue?vue&type=script&lang=js"
export * from "./CategoriesComponent.vue?vue&type=script&lang=js"
import style0 from "./CategoriesComponent.vue?vue&type=style&index=0&id=e31d23ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31d23ee",
  null
  
)

export default component.exports